export const authenticationQueryKeys = {};

export const authenticationMutationKeys = {
  login: ["login"] as const,
  loginFromStorage: ["loginFromStorage"] as const,
};
